// Sample data for previewing the dashboard before the API endpoints are live.
// Toggled from the "Demo data" switch in the page header (development builds only).
// Delete this file and its two usages in index.js once the API is wired up.

import moment from 'moment';
import {
  PF_ACTION_AUTO_RESOLVED_PAYMENT_SUCCEEDED,
  PF_ACTION_CONTACTED_AWAITING_CONFIRMATION,
  PF_ACTION_CONTACTED_REQUESTED_CALLBACK,
  PF_ACTION_CUSTOMER_NOT_REACHABLE,
  PF_ACTION_DUPLICATE_ORDER,
  PF_ACTION_NOT_INTERESTED,
  PF_ACTION_PENDING_REVIEW,
  PF_ACTION_PLACED_NEW_ORDER,
  PF_ACTION_PRICE_CHANGE,
  PF_ACTION_REPROCESSED_SUCCESSFULLY,
  PF_OUTCOME_CONVERTED,
  PF_OUTCOME_NOT_CONVERTED,
  PF_TRIGGER_HIGH_VALUE,
  PF_TRIGGER_REPEAT_FAILURE,
  PF_TRIGGER_STANDARD,
} from '../../../constants/paymentFailedOrders';

const minutesAgo = (minutes) =>
  moment().subtract(minutes, 'minutes').format('YYYY-MM-DD HH:mm:ss');

const hoursAgo = (hours) =>
  moment().subtract(hours, 'hours').format('YYYY-MM-DD HH:mm:ss');

let sequence = 0;
const makeRow = (row) => {
  sequence += 1;
  return {
    id: sequence,
    __demo: true,
    country: 'ae',
    currency: 'AED',
    retry_count: 1,
    outcome_type: null,
    closed_at: null,
    resolved_order_no: '',
    remarks: '',
    updated_by_username: '',
    updated_at: null,
    history: [],
    ...row,
  };
};

export const DEMO_ROWS = [
  makeRow({
    reference_no: '100234871',
    full_name: 'Ahmed Al Mansoori',
    phone: '+971501234567',
    email: 'ahmed.mansoori@gmail.com',
    grand_total: 12499,
    payment_mode: 'payfort_fort_cc',
    gateway: 'PayFort',
    payment_failure_reason: 'Do not honour (issuer declined)',
    order_created_at: minutesAgo(12),
    trigger_reason: PF_TRIGGER_HIGH_VALUE,
    retry_count: 2,
    action_status: PF_ACTION_PENDING_REVIEW,
  }),
  makeRow({
    reference_no: '100234863',
    full_name: 'Priya Nair',
    phone: '+971559876543',
    email: 'priya.nair@outlook.com',
    grand_total: 8790,
    payment_mode: 'tabby',
    gateway: 'Tamara',
    payment_failure_reason: 'Insufficient funds',
    order_created_at: minutesAgo(26),
    trigger_reason: PF_TRIGGER_REPEAT_FAILURE,
    retry_count: 4,
    action_status: PF_ACTION_PENDING_REVIEW,
  }),
  makeRow({
    reference_no: '100234840',
    full_name: 'Mohammed Rashid',
    phone: '+971552223344',
    email: 'm.rashid@yahoo.com',
    grand_total: 6250,
    payment_mode: 'checkoutcom_card_payment',
    gateway: 'Checkout',
    payment_failure_reason: '3DS authentication failed',
    order_created_at: hoursAgo(2),
    trigger_reason: PF_TRIGGER_HIGH_VALUE,
    retry_count: 3,
    action_status: PF_ACTION_CONTACTED_AWAITING_CONFIRMATION,
    remarks: 'Customer will retry with another card this evening.',
    updated_by_username: 'fatima.k',
    updated_at: minutesAgo(45),
    history: [
      {
        id: 2,
        action_status: PF_ACTION_CONTACTED_AWAITING_CONFIRMATION,
        remarks: 'Customer will retry with another card this evening.',
        updated_by_username: 'fatima.k',
        created_at: minutesAgo(45),
      },
      {
        id: 1,
        action_status: PF_ACTION_PENDING_REVIEW,
        remarks: 'Auto-created by high value cron.',
        updated_by_username: '',
        created_at: hoursAgo(2),
      },
    ],
  }),
  makeRow({
    reference_no: '100234812',
    full_name: 'Sara Ibrahim',
    phone: '+971544455667',
    email: 'sara.ibrahim@gmail.com',
    grand_total: 1899,
    payment_mode: 'tap',
    gateway: 'Tap',
    payment_failure_reason: '',
    order_created_at: hoursAgo(5),
    trigger_reason: PF_TRIGGER_STANDARD,
    action_status: PF_ACTION_CONTACTED_REQUESTED_CALLBACK,
    remarks: 'Asked to be called back after 6 PM.',
    updated_by_username: 'imran.s',
    updated_at: hoursAgo(3),
    history: [
      {
        id: 1,
        action_status: PF_ACTION_CONTACTED_REQUESTED_CALLBACK,
        remarks: 'Asked to be called back after 6 PM.',
        updated_by_username: 'imran.s',
        created_at: hoursAgo(3),
      },
    ],
  }),
  makeRow({
    reference_no: '100234799',
    full_name: 'John Mathew',
    phone: '+971507778899',
    email: 'john.mathew@gmail.com',
    grand_total: 15400,
    payment_mode: 'payfort_fort_installments',
    gateway: 'PayFort',
    payment_failure_reason: 'Transaction timeout',
    order_created_at: hoursAgo(7),
    trigger_reason: PF_TRIGGER_HIGH_VALUE,
    retry_count: 2,
    action_status: PF_ACTION_PLACED_NEW_ORDER,
    outcome_type: PF_OUTCOME_CONVERTED,
    resolved_order_no: '100235004',
    remarks: 'Placed a fresh order over the phone, paid by link.',
    updated_by_username: 'fatima.k',
    updated_at: hoursAgo(6),
    closed_at: hoursAgo(6),
    history: [
      {
        id: 2,
        action_status: PF_ACTION_PLACED_NEW_ORDER,
        remarks: 'Placed a fresh order over the phone, paid by link.',
        updated_by_username: 'fatima.k',
        created_at: hoursAgo(6),
      },
      {
        id: 1,
        action_status: PF_ACTION_CONTACTED_AWAITING_CONFIRMATION,
        remarks: 'Reached the customer, sending a payment link.',
        updated_by_username: 'fatima.k',
        created_at: hoursAgo(7),
      },
    ],
  }),
  makeRow({
    reference_no: '100234780',
    full_name: 'Layla Hassan',
    phone: '+971503334455',
    email: 'layla.hassan@gmail.com',
    grand_total: 2450,
    payment_mode: 'apple_pay',
    gateway: 'PayFort',
    payment_failure_reason: 'Card expired',
    order_created_at: hoursAgo(9),
    trigger_reason: PF_TRIGGER_STANDARD,
    action_status: PF_ACTION_REPROCESSED_SUCCESSFULLY,
    outcome_type: PF_OUTCOME_CONVERTED,
    remarks: 'Payment reprocessed on the same order.',
    updated_by_username: 'imran.s',
    updated_at: hoursAgo(8),
    closed_at: hoursAgo(8),
    history: [
      {
        id: 1,
        action_status: PF_ACTION_REPROCESSED_SUCCESSFULLY,
        remarks: 'Payment reprocessed on the same order.',
        updated_by_username: 'imran.s',
        created_at: hoursAgo(8),
      },
    ],
  }),
  makeRow({
    reference_no: '100234755',
    full_name: 'Vikram Shetty',
    phone: '+971561112233',
    email: 'vikram.shetty@gmail.com',
    grand_total: 999,
    payment_mode: 'spotiipay',
    gateway: 'Spotii',
    payment_failure_reason: 'Declined by BNPL provider',
    order_created_at: hoursAgo(14),
    trigger_reason: PF_TRIGGER_STANDARD,
    action_status: PF_ACTION_CUSTOMER_NOT_REACHABLE,
    outcome_type: PF_OUTCOME_NOT_CONVERTED,
    remarks: 'Three call attempts, no answer.',
    updated_by_username: 'noor.a',
    updated_at: hoursAgo(11),
    closed_at: hoursAgo(11),
    history: [
      {
        id: 1,
        action_status: PF_ACTION_CUSTOMER_NOT_REACHABLE,
        remarks: 'Three call attempts, no answer.',
        updated_by_username: 'noor.a',
        created_at: hoursAgo(11),
      },
    ],
  }),
  makeRow({
    reference_no: '100234731',
    full_name: 'Aisha Abdullah',
    phone: '+971588889900',
    email: 'aisha.abdullah@gmail.com',
    grand_total: 5600,
    payment_mode: 'tap_apple_pay',
    gateway: 'Tap',
    payment_failure_reason: 'Authentication cancelled by user',
    order_created_at: hoursAgo(20),
    trigger_reason: PF_TRIGGER_HIGH_VALUE,
    action_status: PF_ACTION_AUTO_RESOLVED_PAYMENT_SUCCEEDED,
    outcome_type: PF_OUTCOME_CONVERTED,
    remarks: 'Customer completed payment on a later attempt.',
    updated_by_username: '',
    updated_at: hoursAgo(19),
    closed_at: hoursAgo(19),
    history: [
      {
        id: 1,
        action_status: PF_ACTION_AUTO_RESOLVED_PAYMENT_SUCCEEDED,
        remarks: 'Closed by cron - a paid order exists for this customer.',
        updated_by_username: '',
        created_at: hoursAgo(19),
      },
    ],
  }),
  makeRow({
    reference_no: '100234700',
    full_name: 'Rakesh Kumar',
    phone: '+971502223311',
    email: 'rakesh.k@gmail.com',
    grand_total: 3200,
    payment_mode: 'cashew',
    gateway: 'Cashew',
    payment_failure_reason: 'Limit exceeded',
    order_created_at: hoursAgo(26),
    trigger_reason: PF_TRIGGER_REPEAT_FAILURE,
    retry_count: 5,
    action_status: PF_ACTION_NOT_INTERESTED,
    outcome_type: PF_OUTCOME_NOT_CONVERTED,
    remarks: 'Bought the item elsewhere.',
    updated_by_username: 'noor.a',
    updated_at: hoursAgo(24),
    closed_at: hoursAgo(24),
    history: [
      {
        id: 1,
        action_status: PF_ACTION_NOT_INTERESTED,
        remarks: 'Bought the item elsewhere.',
        updated_by_username: 'noor.a',
        created_at: hoursAgo(24),
      },
    ],
  }),
  makeRow({
    reference_no: '100234688',
    full_name: 'Fatima Zahra',
    phone: '+971555556677',
    email: 'fatima.zahra@gmail.com',
    grand_total: 7450,
    payment_mode: 'payfort_fort_cc',
    gateway: 'PayFort',
    payment_failure_reason: 'Suspected fraud - issuer block',
    order_created_at: hoursAgo(30),
    trigger_reason: PF_TRIGGER_HIGH_VALUE,
    action_status: PF_ACTION_DUPLICATE_ORDER,
    outcome_type: PF_OUTCOME_NOT_CONVERTED,
    remarks: 'Same basket already paid on order 100234690.',
    updated_by_username: 'imran.s',
    updated_at: hoursAgo(28),
    closed_at: hoursAgo(28),
    history: [
      {
        id: 1,
        action_status: PF_ACTION_DUPLICATE_ORDER,
        remarks: 'Same basket already paid on order 100234690.',
        updated_by_username: 'imran.s',
        created_at: hoursAgo(28),
      },
    ],
  }),
  makeRow({
    reference_no: '100234650',
    full_name: 'Omar Farooq',
    phone: '+971509998877',
    email: 'omar.farooq@gmail.com',
    grand_total: 4150,
    payment_mode: 'tap_knet',
    gateway: 'Tap',
    payment_failure_reason: '',
    order_created_at: hoursAgo(36),
    trigger_reason: PF_TRIGGER_STANDARD,
    action_status: PF_ACTION_PRICE_CHANGE,
    outcome_type: PF_OUTCOME_NOT_CONVERTED,
    remarks: 'Price increased after the promo ended, customer declined.',
    updated_by_username: 'noor.a',
    updated_at: hoursAgo(33),
    closed_at: hoursAgo(33),
    history: [
      {
        id: 1,
        action_status: PF_ACTION_PRICE_CHANGE,
        remarks: 'Price increased after the promo ended, customer declined.',
        updated_by_username: 'noor.a',
        created_at: hoursAgo(33),
      },
    ],
  }),
  makeRow({
    reference_no: '100234611',
    full_name: 'Neha Sharma',
    phone: '+971521234000',
    email: 'neha.sharma@gmail.com',
    grand_total: 1275,
    payment_mode: 'postpay',
    gateway: 'PostPay',
    payment_failure_reason: 'Declined by BNPL provider',
    order_created_at: hoursAgo(40),
    trigger_reason: PF_TRIGGER_STANDARD,
    action_status: PF_ACTION_PENDING_REVIEW,
  }),
];

// Rough client side version of the API filters, so the filter bar visibly works in demo mode
export const filterDemoRows = (filters, rows = DEMO_ROWS) =>
  rows.filter((row) => {
    if (filters.record_state === 'open' && row.closed_at) return false;
    if (filters.record_state === 'closed' && !row.closed_at) return false;
    if (
      filters.record_state === 'converted' &&
      row.outcome_type !== 'converted'
    ) {
      return false;
    }
    if (
      filters.action_status?.length &&
      !filters.action_status.includes(row.action_status)
    ) {
      return false;
    }
    if (filters.trigger_reason && row.trigger_reason !== filters.trigger_reason) {
      return false;
    }
    if (filters.payment_mode && row.payment_mode !== filters.payment_mode) return false;
    if (filters.country && row.country !== filters.country) return false;
    if (
      filters.payment_failure_reason &&
      !(row.payment_failure_reason || '')
        .toLowerCase()
        .includes(filters.payment_failure_reason.toLowerCase())
    ) {
      return false;
    }
    if (filters.search) {
      const needle = filters.search.toLowerCase();
      const haystack = [row.reference_no, row.full_name, row.phone, row.email]
        .join(' ')
        .toLowerCase();
      if (!haystack.includes(needle)) return false;
    }
    if (filters.date_from && moment(row.order_created_at).isBefore(filters.date_from, 'day')) {
      return false;
    }
    if (filters.date_to && moment(row.order_created_at).isAfter(filters.date_to, 'day')) {
      return false;
    }
    return true;
  });

const buildDemoDaily = (rows) => {
  const byDate = {};
  rows.forEach((row) => {
    const date = moment(row.order_created_at).format('YYYY-MM-DD');
    const point = byDate[date] || { date, failed: 0, converted: 0 };
    point.failed += 1;
    if (row.outcome_type === 'converted') point.converted += 1;
    byDate[date] = point;
  });
  return Object.values(byDate).sort((a, b) => new Date(a.date) - new Date(b.date));
};

const countGroup = (rows) => ({
  still_open: rows.filter((row) => !row.closed_at).length,
  closed: rows.filter((row) => row.closed_at && row.outcome_type !== 'converted')
    .length,
  converted: rows.filter((row) => row.outcome_type === 'converted').length,
  total: rows.length,
});

export const buildDemoSummary = (rows) => {
  const converted = rows.filter((row) => row.outcome_type === 'converted');
  const attended = rows.filter((row) => Boolean(row.updated_by_username));
  const notConverted = rows.filter((row) => row.outcome_type === 'not_converted');
  const open = rows.filter((row) => !row.closed_at);


  return {
    total: rows.length,
    converted: converted.length,
    not_converted: notConverted.length,
    open: open.length,
    conversion_rate: rows.length
      ? ((converted.length / rows.length) * 100).toFixed(1)
      : '0.0',
    revenue_recovered: converted.reduce(
      (sum, row) => sum + Number(row.grand_total || 0),
      0,
    ),
    currency: 'AED',
    daily: buildDemoDaily(rows),
    attended: countGroup(attended),
    not_attended: countGroup(
      rows.filter((row) => !row.updated_by_username),
    ),
  };
};
